import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import { claimStatusesDataSource } from 'infrastructure/data-sources/claim-statuses';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';
import type { IClaimStatusItem } from 'infrastructure/data-sources/claim-statuses';

type Options = IBaseSelectBoxOption<IClaimStatusItem['id'], IClaimStatusItem>[];

interface IClaimStatusSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClaimStatusSelectBox: React.FC<IClaimStatusSelectBoxProps> = (props) => {
  const dataSource = useMemo(() => claimStatusesDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClaimStatusSelectBox;
